import React from "react"

import {IconButton} from "@irati/ui/src/Button"
import IconWrapper from "./IconWrapper"
import {HexCode, ColorPreview, WithMargin} from "./styled"

interface Props {
  onClick: () => void,
  itemId: boolean,
  isLight: boolean,
  selectedId?: string | null,
  color: string,
  hexCode: string
}

const ColorPreviewItem = ({onClick, itemId, color, isLight, hexCode, selectedId = null}: Props) => (
  <WithMargin>
    <ColorPreview small color={color} selectedId={selectedId} itemId={itemId} onClick={onClick}>
      <HexCode>{hexCode}</HexCode>
    </ColorPreview>
    <IconWrapper
      onClick={onClick}
      hide={!(selectedId === itemId)}>
      <IconButton
        inline
        icon="tick"
        onClick={() => {}}
        color={isLight ? "black" : "white"} />
    </IconWrapper>
  </WithMargin>
)

export default ColorPreviewItem
